// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"c616a2a5","72":"f8c3eb36","346":"d39a2002"}[chunkId] + ".chunk.js";
};